import { IControlePatrimonioRepository } from "../../domain/repositories/ControledePatrimonio";
import { IControlePatrimonioService } from "../services/controlePatrimonioService";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { ControlePatrimonioLista } from "../../domain/models/controle_patrimonio_lista";

import {
  GetControlePatrimonioControleByIdRequestModel,
  GetControlePatrimonioControleByIdResponseModel,
} from "../../domain/models/ControledePatrimonioControleModel";

import {
  GetControledePatrimonioInspecaoByIdRequestModel,
  GetControledePatrimonioInspecaoByIdResponseModel,
} from "../../domain/models/ControledePatrimonioInspecao";

import {
  GetMaquinaEquipArquivoByIdRequestModel,
  GetMaquinaEquipArquivoByIdResponseModel,
} from "../../domain/models/MaquinasEquipItensArquivo";

import { ControlePatrimonioDetalhes } from "../../domain/models/controle_patrimonio_detalhes";
import { ControlePatrimonioArquivoLista } from "../../domain/models/controle_patrimonio_arquivo_lista";
import { MaquinaEquipItem } from "../../domain/models/maquina_equip_item";
import { ControleCentroCustoLista } from "../../domain/models/controle_centro_custo_lista";
import { InspecaoMaquinaEquipLista } from "../../domain/models/inspecao_maquina_equip_lista";
import { MaquinaEquipDropdown } from "../../domain/models/maquina_equip_dropdown";
import { ControleCentroCustoDetalhe } from "../../domain/models/controle_centro_custo_detalhe";
import { ControleEstatisticas } from "../../domain/models/controle_estatisticas";
import { InspecaoMaquinaEquipDetalhes } from "../../domain/models/inspecao_maquinas_equip_detalhes";
import { InspecaoMaquinaEquipItemLista } from "../../domain/models/inspecao_maquina_equip_item_lista";
import { DownloadInspecaoMaquinaEquipArquivo } from "../../domain/models/inspecao_maquina_equip_arquivo_download";
import { ManutencaoModel } from "../../domain/models/manutencao_model";
import { ManutencaoLista } from "../../domain/models/manutencao_lista";
import { ChecklistMaquinaEquipModel } from "../../domain/models/checklist_maquina_equip";
import { ChecklistMaquinaEquipItemModel } from "../../domain/models/checklist_maquina_equip_item";
import { InspecaoPatrimonioModel } from "../../domain/models/inspecao_patrimonio";
import { InspecaoPatrimonioItensModel } from "../../domain/models/Inspecao_patrimonio_itens";
import { PatrimonioChecklistMaquinaEquipModel } from "../../domain/models/patrimonio_checklist_maquina_equip";
import { PatrimonioMaquinaEquipModel } from "../../domain/models/patrimonio_maquina_equip";
import { PatrimonioCentroCustoModel } from "../../domain/models/patrimonio_centro_custo";
import { PatrimonioCentroCustoListaModel } from "../../domain/models/patrimonio_centro_custo_lista";
import { PatrimonioMaquinaEquipListaModel } from "../../domain/models/patrimonio_maquina_equip_lista";
import { DropDownItem } from "../../../../common/data/daos/get_list_drop_down_response";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { PatrimonioChecklistInfo } from "../../domain/models/patrimonio_checklist_info";
import { OcorrenciaInspecaoPatrimonioLista } from "../../domain/models/ocorrencia_inspecao_patrimonio_lista";
import { OcorrenciaInspecaoPatrimonioModel } from "../../domain/models/ocorrencia_inspecao_patrimonio";

export class ControlePatrimonioRepository implements IControlePatrimonioRepository {
  constructor(private readonly service: IControlePatrimonioService) { }
  getAllControlePatrimonioArquivos(
    idMaquinaEquip: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ControlePatrimonioArquivoLista>> {
    throw new Error("Method not implemented.");
  }
  //#region ControledePatrimonio

  async getAllControlePatrimonio(
    codigo: string | null,
    descricao: string | null,
    status: number | null,
    localizacao: string | null,
    centroCusto: number[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ControlePatrimonioLista>> {
    return await this.service.getAllControlePatrimonio({
      codigo,
      descricao,
      status,
      localizacao,
      centroCusto,
      page,
      rowsPerPage,
    });
  }

  async getControlePatrimonioById(
    idMaquinaEquip: number,
  ): Promise<ControlePatrimonioDetalhes | null> {
    const response = await this.service.getByIdControlePatrimonio({
      idMaquinaEquip,
    });
    return response.item;
  }

  async createControlePatrimonio(
    ativo: boolean | null,
    dataCadastro: Date | null,
    codigo: string | null,
    idCentroCusto: number | null,
    descricao: string | null,
    criterioAceitacao: string | null,
    referenciaAceitacao: string | null,
    quantidade: number | null,
    dataAquisicao: Date | null,
    dataGarantia: Date | null,
    descResponsavelMonit: string | null,
    idFuncionarioMonit: number | null,
    idFornecedorMonit: number | null,
    descResponsavelResp: string | null,
    idFuncionarioResp: number | null,
    tipoMonitoramento: string | null,
    frequenciaVerificacao: number | null,
    dataProxVerificacao: Date | null,
    dataVerificacao: Date | null,
    marca: string | null,
    modelo: string | null,
    valor: number | null,
    tipo: string | null,
    idFornecedor: number | null,
    status: number | null,
    fatorGerador: number | null,
    faixaDeUso: string | null,
    localizacao: string | null,
    observacao: string | null,
    tipoCalibradoMonit: number | null,
  ): Promise<number> {
    const response = await this.service.createControlePatrimonio({
      ativo,
      dataCadastro,
      codigo,
      idCentroCusto,
      descricao,
      criterioAceitacao,
      referenciaAceitacao,
      quantidade,
      dataAquisicao,
      dataGarantia,
      descResponsavelMonit,
      idFuncionarioMonit,
      idFornecedorMonit,
      descResponsavelResp,
      idFuncionarioResp,
      tipoMonitoramento,
      frequenciaVerificacao,
      dataProxVerificacao,
      dataVerificacao,
      marca,
      modelo,
      valor,
      tipo,
      idFornecedor,
      status,
      fatorGerador,
      faixaDeUso,
      localizacao,
      observacao,
      tipoCalibradoMonit,
    });

    return response.idMaquinaEquip;
  }

  async updateControlePatrimonio(
    idMaquinaEquip: number,
    ativo: boolean | null,
    dataCadastro: Date | null,
    codigo: string | null,
    idCentroCusto: number | null,
    descricao: string | null,
    criterioAceitacao: string | null,
    referenciaAceitacao: string | null,
    quantidade: number | null,
    dataAquisicao: Date | null,
    dataGarantia: Date | null,
    descResponsavelMonit: string | null,
    idFuncionarioMonit: number | null,
    idFornecedorMonit: number | null,
    descResponsavelResp: string | null,
    idFuncionarioResp: number | null,
    tipoMonitoramento: string | null,
    frequenciaVerificacao: number | null,
    dataProxVerificacao: Date | null,
    dataVerificacao: Date | null,
    marca: string | null,
    modelo: string | null,
    valor: number | null,
    tipo: string | null,
    idFornecedor: number | null,
    status: number | null,
    fatorGerador: number | null,
    faixaDeUso: string | null,
    localizacao: string | null,
    observacao: string | null,
    tipoCalibradoMonit: number | null,
  ): Promise<void> {
    await this.service.updateControlePatrimonio({
      idMaquinaEquip,
      ativo,
      dataCadastro,
      codigo,
      idCentroCusto,
      descricao,
      criterioAceitacao,
      referenciaAceitacao,
      quantidade,
      dataAquisicao,
      dataGarantia,
      descResponsavelMonit,
      idFuncionarioMonit,
      idFornecedorMonit,
      descResponsavelResp,
      idFuncionarioResp,
      tipoMonitoramento,
      frequenciaVerificacao,
      dataProxVerificacao,
      dataVerificacao,
      marca,
      modelo,
      valor,
      tipo,
      idFornecedor,
      status,
      fatorGerador,
      faixaDeUso,
      localizacao,
      observacao,
      tipoCalibradoMonit,
    });
  }

  async deleteControlePatrimonio(idMaquinaEquip: number): Promise<void> {
    await this.service.deleteControlePatrimonio({ idMaquinaEquip });
  }

  async dropDownMaquinaEquip(): Promise<MaquinaEquipDropdown[]> {
    const response = await this.service.dropDownMaquinaEquip({});
    return response.items;
  }

  async downloadControlePatrimonioArquivo(
    idMaquinaEquipArquivo: number,
  ): Promise<Blob> {
    const response = await this.service.downloadControlePatrimonioArquivo({
      idMaquinaEquipArquivo,
    });
    return response;
  }

  //#endregion

  //#region ControledePatrimonio Controle
  async getControlePatrimonioControleList(
    centroCusto: number[] | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ControleCentroCustoLista>> {
    return await this.service.getAllControlePatrimonioControle({
      centroCusto,
      status,
      page,
      rowsPerPage,
    });
  }

  async getControlePatrimonioControleById(
    request: GetControlePatrimonioControleByIdRequestModel,
  ): Promise<GetControlePatrimonioControleByIdResponseModel> {
    const response =
      await this.service.getByIdControlePatrimonioControle(request);
    return { ...response };
  }

  async createControlePatrimonioControle(
    idCentroCusto: number,
  ): Promise<number> {
    const response = await this.service.createControlePatrimonioControle({
      idCentroCusto,
    });
    return response.idControleCentroCusto;
  }

  async updateControlePatrimonioControle(
    idControleCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.service.updateControlePatrimonioControle({
      idControleCentroCusto,
      idCentroCusto,
    });
  }

  async deleteControlePatrimonioControle(
    idControleCentroCusto: number,
  ): Promise<void> {
    await this.service.deleteControlePatrimonioControle({
      idControleCentroCusto,
    });
  }

  async getControledePatrimonioInspecaoList(
    idControleCentroCusto: number,
    maquinaEquip: number[] | null,
    page: number,
    rowsPerPage: number,
    dataEntradaDe?: Date | null,
    dataEntradaAte?: Date | null,
    codigo?: string | null,
  ): Promise<Paginated<InspecaoMaquinaEquipLista>> {
    return await this.service.getAllInspecaoMaquinaEquip({
      idControleCentroCusto,
      maquinaEquip,
      page,
      rowsPerPage,
      dataEntradaDe,
      dataEntradaAte,
      codigo,
    });
  }

  async getControledePatrimonioInspecaoById(
    request: GetControledePatrimonioInspecaoByIdRequestModel,
  ): Promise<GetControledePatrimonioInspecaoByIdResponseModel> {
    const response = await this.service.getByIdInspecaoMaquinaEquip(request);
    return { ...response };
  }

  async createControledePatrimonioInspecao(
    idControleCentroCusto: number,
    dataInspecao: Date | null,
    idMaquinaEquip: number,
    codigoMaquinaEquip: string | null,
  ): Promise<number> {
    const response = await this.service.createInspecaoMaquinaEquip({
      idControleCentroCusto,
      dataInspecao,
      idMaquinaEquip,
      codigoMaquinaEquip,
    });
    return response.idInspecaoMaquinaEquip;
  }

  async updateControledePatrimonioInspecao(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    dataInspecao: Date | null,
    idMaquinaEquip: number,
    codigoMaquinaEquip: string | null,
  ): Promise<void> {
    await this.service.updateInspecaoMaquinaEquip({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      dataInspecao,
      idMaquinaEquip,
      codigoMaquinaEquip,
    });
  }

  async deleteControledePatrimonioInspecao(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deleteInspecaoMaquinaEquip({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
    });
  }
  //#endregion

  //#region ControledePatrimonio MaquinasEquipItens

  async getControledePatrimonioMaquinasEquipItensList(
    idMaquinaEquip: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<MaquinaEquipItem>> {
    return await this.service.getAllMaquinasEquipItens({
      idMaquinaEquip,
      page,
      rowsPerPage,
    });
  }

  async createControledePatrimonioMaquinasEquipItens(
    idMaquinaEquip: number,
    ordem: string,
    descricao: string,
  ): Promise<number> {
    const response = await this.service.createMaquinasEquipItens({
      idMaquinaEquip,
      ordem,
      descricao,
    });
    return response.idItemMaquinaEquip;
  }

  async updateControledePatrimonioMaquinasEquipItens(
    idItemMaquinaEquip: number,
    idMaquinaEquip: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.service.updateMaquinasEquipItens({
      idItemMaquinaEquip,
      idMaquinaEquip,
      ordem,
      descricao,
    });
  }

  async deleteControledePatrimonioMaquinasEquipItens(
    idItemMaquinaEquip: number,
    idMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deleteMaquinasEquipItens({
      idItemMaquinaEquip,
      idMaquinaEquip,
    });
  }

  //#endregion

  //#region ControledePatrimonio MaquinaEquipArquivo

  async getAllControlePatrimonioArquivo(
    idMaquinaEquip: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ControlePatrimonioArquivoLista>> {
    return await this.service.getAllControlePatrimonioArquivo({
      idMaquinaEquip,
      page,
      rowsPerPage,
    });
  }

  async getControledePatrimonioMaquinaEquipArquivoById(
    request: GetMaquinaEquipArquivoByIdRequestModel,
  ): Promise<GetMaquinaEquipArquivoByIdResponseModel> {
    const response = await this.service.getMaquinaEquipArquivoById(request);
    return { ...response };
  }

  async createControledePatrimonioMaquinaEquipArquivo(
    idMaquinaEquip: number,
    descricao: string,
    arquivoNome: string | null,
    arquivoData: File | null,
  ): Promise<number> {
    const response = await this.service.createMaquinaEquipArquivo({
      idMaquinaEquip,
      descricao,
      arquivoNome,
      arquivoData,
    });

    return response.idMaquinaEquipArquivo;
  }

  async updateControledePatrimonioMaquinaEquipArquivo(
    idMaquinaEquipArquivo: number,
    idMaquinaEquip: number,
    descricao: string,
    arquivoNome: string | null,
    arquivoData: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.service.updateMaquinaEquipArquivo({
      idMaquinaEquipArquivo,
      idMaquinaEquip,
      descricao,
      arquivoNome,
      arquivoData,
      limparArquivo,
    });
  }

  async deleteControledePatrimonioMaquinaEquipArquivo(
    idMaquinaEquipArquivo: number,
    idMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deleteMaquinaEquipArquivo({
      idMaquinaEquipArquivo,
      idMaquinaEquip,
    });
  }

  //#endregion

  async getControleCentroCustoById(
    idControleCentroCusto: number,
  ): Promise<ControleCentroCustoDetalhe | null> {
    const response = await this.service.getControleCentroCustoById({
      idControleCentroCusto,
    });
    return response.item;
  }

  async getControleCentroCustoEstatisticas(
    idControleCentroCusto: number,
  ): Promise<ControleEstatisticas | null> {
    const response = await this.service.getControleCentroCustoEstatisticas({
      idControleCentroCusto,
    });
    return response.item;
  }

  async updateMetaStatusControleCentroCusto(
    idControleCentroCusto: number,
    meta: number,
    status: number,
  ): Promise<void> {
    await this.service.updateMetaStatusControleCentroCusto({
      idControleCentroCusto,
      meta,
      status,
    });
  }

  async copyInspecaoMaquinaEquip(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    nroCopias: number,
  ): Promise<void> {
    await this.service.copyInspecaoMaquinaEquip({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      nroCopias,
    });
  }

  async getInspecaoMaquinasEquipById(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
  ): Promise<InspecaoMaquinaEquipDetalhes | null> {
    const response = await this.service.getInspecaoMaquinasEquipById({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
    });
    return response.item;
  }

  async getAllInspecaoMaquinasEquipItem(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<InspecaoMaquinaEquipItemLista>> {
    return await this.service.getAllInspecaoMaquinasEquipItem({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      page,
      rowsPerPage,
    });
  }

  async updateInspecaoMaquinasEquipDetail(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    idFuncionarioInspecionado: number | null,
    idFuncionarioAprovado: number | null,
    status: number,
    dataEncerramento: Date | null,
    descricaoProblema: string | null,
    correcaoProblema: string | null,
    arquivo1Nome: string | null,
    arquivo1Data: string | null,
    arquivo2Nome: string | null,
    arquivo2Data: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    itens:
      | {
        idInspecaoMaquinaEquipItens: number;
        inspecao1: string;
        inspecao2: string;
      }[]
      | null,
  ): Promise<void> {
    await this.service.updateInspecaoMaquinasEquipDetail({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      idFuncionarioInspecionado,
      idFuncionarioAprovado,
      status,
      dataEncerramento,
      descricaoProblema,
      correcaoProblema,
      arquivo1Nome,
      arquivo1Data,
      arquivo2Nome,
      arquivo2Data,
      limparArquivo1,
      limparArquivo2,
      itens,
    });
  }

  async downloadInspecaoMaquinaEquipArquivo(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    fileIndex: number,
  ): Promise<DownloadInspecaoMaquinaEquipArquivo | null> {
    const response = await this.service.downloadInspecaoMaquinaEquipArquivo({
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      fileIndex,
    });

    return response.item;
  }

  //#region Manutencao
  async getAllListagemManutencao(
    nroManutencao: number,
    idsMaquinaEquip?: number[],
    idsCentroCusto?: number[],
    idsFuncionarioSolicitante?: number[],
    idsFuncionarioAprovacao?: number[],
    idsFornecedorResponsavel?: number[],
    dataSolicitacaoDe?: Date,
    dataSolicitacaoAte?: Date,
    status?: string[],

    currentPage?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ManutencaoLista>> {
    return this.service.getAllListagemManutencao({
      nroManutencao,
      idsMaquinaEquip,
      idsCentroCusto,
      idsFuncionarioSolicitante,
      idsFuncionarioAprovacao,
      idsFornecedorResponsavel,
      dataSolicitacaoDe,
      dataSolicitacaoAte,
      status,
      currentPage,
      rowsPerPage,
    });
  }

  async getManutencaoById(idManutencao: number): Promise<ManutencaoModel> {
    const result = await this.service.getManutencaoById({ idManutencao });
    return result;
  }

  async createManutencao(
    nroManutencao?: number,
    idManutencao?: number,
    status?: string,
    idCentroCusto?: number,
    idMaquinaEquip?: number,
    idFuncionarioSolicitante?: number,
    idFuncionarioAprovacao?: number,
    idFornecedorResponsavel?: number,
    valorOrcamento?: number,
    dataPrevConclusao?: Date,
    dataConclusao?: Date,
    dataAprovacao?: Date,
    descricao?: string,
    observacao?: string,
    dataSolicitacao?: Date,
    nomeArquivo1?: string | null,
    nomeArquivo2?: string | null,
    nomeArquivo3?: string | null,
    arquivo1?: File | null,
    arquivo2?: File | null,
    arquivo3?: File | null,
  ): Promise<number> {
    const result = await this.service.createManutencao({
      nroManutencao,
      idManutencao,
      status,
      idCentroCusto,
      idMaquinaEquip,
      idFuncionarioSolicitante,
      idFuncionarioAprovacao,
      idFornecedorResponsavel,
      valorOrcamento,
      dataPrevConclusao,
      dataConclusao,
      dataAprovacao,
      descricao,
      observacao,
      dataSolicitacao,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      arquivo1,
      arquivo2,
      arquivo3,
    });

    return result.idManutencao;
  }

  async deleteManutencao(idManutencao: number): Promise<void> {
    await this.service.deleteManutencao({ idManutencao });
  }

  async updateManutencao(
    idManutencao: number,
    status: string,
    idCentroCusto?: number,
    idFuncionarioAprovacao?: number,
    dataPrevConclusao?: Date,
    dataConclusao?: Date,
    dataAprovacao?: Date,
    observacao?: string,
    idMaquinaEquip?: number,
    idFuncionarioSolicitante?: number,
    idFornecedorResponsavel?: number,
    valorOrcamento?: number,
    descricao?: string,
    dataSolicitacao?: Date,
    idFuncionarioResponsavel?: number,
    tipoManutencao?: number,
    motivoReprovacao?: string,
    nomeArquivo1?: string | null,
    nomeArquivo2?: string | null,
    nomeArquivo3?: string | null,
    arquivo1?: File | null,
    arquivo2?: File | null,
    arquivo3?: File | null,
    limparArquivo1?: boolean,
    limparArquivo2?: boolean,
    limparArquivo3?: boolean
  ): Promise<void> {
    await this.service.updateManutencao({
      idManutencao,
      status,
      idCentroCusto,
      idFuncionarioAprovacao,
      dataPrevConclusao,
      dataConclusao,
      dataAprovacao,
      observacao,
      idMaquinaEquip,
      idFuncionarioSolicitante,
      idFornecedorResponsavel,
      valorOrcamento,
      descricao,
      dataSolicitacao,
      idFuncionarioResponsavel,
      tipoManutencao,
      motivoReprovacao,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      arquivo1,
      arquivo2,
      arquivo3,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3,
    });
  }

  async getManutencaoGerenciarArquivoById(
    idManutencao: number,
    nroArquivo: number,
  ): Promise<Blob> {
    const result = await this.service.getManutencaoGerenciarArquivoById({
      idManutencao,
      nroArquivo,
    });
    return result;
  }

  //#endregion

  //#region  Checklist Maquina Equip

  async getAllChecklistMaquinaEquip(
    status: boolean | null,
    codigo: string | null,
    revisao: string | null,
    descricao: string | null,

    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ChecklistMaquinaEquipModel>> {
    const result = await this.service.getAllChecklistMaquinaEquip({
      status,
      codigo,
      revisao,
      descricao,
      page,
      rowsPerPage,
    });
    return {
      ...result, items: result.items.map(item => ({
        ...item,
        status: item.status === true ? 1 : 0,
      }))
    };
  }

  async getChecklistMaquinaEquipById(
    idChecklistMaquinaEquip: number,
  ): Promise<ChecklistMaquinaEquipModel> {
    const result = await this.service.getChecklistMaquinaEquipById({
      idChecklistMaquinaEquip,
    });
    return result;
  }

  async getChecklistMaquinaEquipDropDown():
    Promise<DropDown[]> {
    const result = await this.service.getChecklistMaquinaEquipDropDown();
    return result.itens.map(item => ({
      ...item,
      title: item.title ?? '',
    }));

  }

  async createChecklistMaquinaEquip(
    codigo?: string,
    revisao?: string,
    descricao?: string,
  ): Promise<number> {
    const result = await this.service.createChecklistMaquinaEquip({
      codigo,
      revisao,
      descricao,
    });
    return result.idChecklistMaquinaEquip;
  }

  async updateChecklistMaquinaEquip(
    idChecklistMaquinaEquip: number,
    status: boolean,
    codigo?: string,
    revisao?: string,
    descricao?: string,
  ): Promise<void> {
    await this.service.updateChecklistMaquinaEquip({
      idChecklistMaquinaEquip,
      status,
      codigo,
      revisao,
      descricao,
    });
  }

  async deleteChecklistMaquinaEquip(
    idChecklistMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deleteChecklistMaquinaEquip({
      idChecklistMaquinaEquip,
    });
  }

  //#endregion

  //#region  Checklist Maquina Equip item

  async getAllChecklistMaquinaEquipItem(
    idChecklistMaquinaEquip: number | null,
    ordem: string | null,
    descricao: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ChecklistMaquinaEquipItemModel>> {
    const result = await this.service.getAllChecklistMaquinaEquipItem({
      idChecklistMaquinaEquip,
      ordem,
      descricao,
      page,
      rowsPerPage,
    });
    return result;
  }

  async getChecklistMaquinaEquipItemById(
    idItemChecklistMaquinaEquip: number,
  ): Promise<ChecklistMaquinaEquipItemModel> {
    const result = await this.service.getChecklistMaquinaEquipItemById({
      idItemChecklistMaquinaEquip,
    });
    return result;
  }

  async createChecklistMaquinaEquipItem(
    idChecklistMaquinaEquip: number,
    ordem?: string,
    descricao?: string,
  ): Promise<number> {
    const result = await this.service.createChecklistMaquinaEquipItem({
      idChecklistMaquinaEquip,
      ordem,
      descricao,
    });
    return result.idChecklistMaquinaEquipItem;
  }

  async updateChecklistMaquinaEquipItem(
    idItemChecklistMaquinaEquip: number,
    ordem?: string,
    descricao?: string,
  ): Promise<void> {
    await this.service.updateChecklistMaquinaEquipItem({
      idItemChecklistMaquinaEquip,
      ordem,
      descricao,
    });
  }

  async deleteChecklistMaquinaEquipItem(
    idItemChecklistMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deleteChecklistMaquinaEquipItem({
      idItemChecklistMaquinaEquip,
    });
  }

  //#endregion


  //#region Inspecao Patrimonio

  async getAllInspecaoPatrimonio(
    idPatrimonioMaquinaEquip: number,
    status: number | null,
    dataDe?: Date | null,
    dataAte?: Date | null,

    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<InspecaoPatrimonioModel>> {
    return await this.service.getAllInspecaoPatrimonio({
      idPatrimonioMaquinaEquip,
      status,
      dataDe,
      dataAte,
      page,
      rowsPerPage,
    });
  }

  async getInspecaoPatrimonioById(
    idInspecaoPatrimonio: number,
  ): Promise<InspecaoPatrimonioModel> {
    const response = await this.service.getInspecaoPatrimonioById({
      idInspecaoPatrimonio,
    });

    return response;
  }

  async createInspecaoPatrimonio(
    idPatrimonioMaquinaEquip: number | null,
    dataInspecao: Date | null,
    descricao: string | null,
  ): Promise<number> {
    const response = await this.service.createInspecaoPatrimonio({
      idPatrimonioMaquinaEquip,
      dataInspecao,
      descricao,
    });
    return response.idInspecaoPatrimonio;
  }

  async updateInspecaoPatrimonio(
    idInspecaoPatrimonio: number,
    idPatrimonioChecklistMaquinaEquip: number | null,
    idFuncionarioAprovado: number | null,
    idFuncionarioInspecionado: number | null,
    dataInspecao: Date | null,
    dataEncerramento: Date | null,
    descricao: string | null,
    observacao: string | null,
    status: number | null,
    inspecaoPatrimonioItens?: {
      idInspecaoPatrimonioItens: number;
      descricao: string | null;
      inspecao1: string | null;
      dataInspecao1: Date | null;
      inspecao2: string | null;
      dataInspecao2: Date | null;
    }[],
  ): Promise<void> {
    await this.service.updateInspecaoPatrimonio({
      idInspecaoPatrimonio,
      idPatrimonioChecklistMaquinaEquip,
      idFuncionarioAprovado,
      idFuncionarioInspecionado,
      dataInspecao,
      dataEncerramento,
      descricao,
      observacao,
      status,
      inspecaoPatrimonioItens,
    });
  }

  async deleteInspecaoPatrimonio(idInspecaoPatrimonio: number): Promise<void> {
    await this.service.deleteInspecaoPatrimonio({ idInspecaoPatrimonio });
  }

  //#endregion




  //#region Inspecao Patrimonio Itens

  async getAllInspecaoPatrimonioItens(
    idInspecaoPatrimonio: number | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<InspecaoPatrimonioItensModel>> {
    return await this.service.getAllInspecaoPatrimonioItens({
      idInspecaoPatrimonio,
      status,

      page,
      rowsPerPage,
    });
  }

  async getInspecaoPatrimonioItensById(
    idInspecaoPatrimonioItens: number,
  ): Promise<InspecaoPatrimonioItensModel> {
    return await this.service.getInspecaoPatrimonioItensById({
      idInspecaoPatrimonioItens,
    });
  }

  async createInspecaoPatrimonioItens(
    idInspecaoPatrimonio: number | null,
    ordem: string | null,
    descricao: string | null,
    inspecao1: string | null,
    inspecao2: string | null,
    dataInspecao1: Date | null,
    dataInspecao2: Date | null,
    status: number | null,
  ): Promise<number> {
    const response = await this.service.createInspecaoPatrimonioItens({
      idInspecaoPatrimonio,
      ordem,
      descricao,
      inspecao1,
      inspecao2,
      dataInspecao1,
      dataInspecao2,
      status,
    });
    return response.idInspecaoPatrimonioItens;
  }

  async updateInspecaoPatrimonioItens(
    idInspecaoPatrimonioItens: number,
    idInspecaoPatrimonio: number | null,
    ordem: string | null,
    descricao: string | null,
    inspecao1: string | null,
    inspecao2: string | null,
    dataInspecao1: Date | null,
    dataInspecao2: Date | null,
    status: number | null,
  ): Promise<void> {
    await this.service.updateInspecaoPatrimonioItens({
      idInspecaoPatrimonioItens,
      idInspecaoPatrimonio,
      ordem,
      descricao,
      inspecao1,
      inspecao2,
      dataInspecao1,
      dataInspecao2,
      status,
    });
  }

  async deleteInspecaoPatrimonioItens(
    idInspecaoPatrimonioItens: number,
  ): Promise<void> {
    await this.service.deleteInspecaoPatrimonioItens({
      idInspecaoPatrimonioItens,
    });
  }

  //#endregion



  //#region Patrimonio Centro Custo

  async getAllPatrimonioCentroCusto(
    status: number | null,
    idsCentroCusto: number[] | null,
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<PatrimonioCentroCustoListaModel>> {
    return this.service.getAllPatrimonioCentroCusto({
      status,
      idsCentroCusto,
      page,
      rowsPerPage,
    });
  }


  async getPatrimonioCentroCustoById(
    idPatrimonioCentroCusto: number,
  ): Promise<PatrimonioCentroCustoModel> {
    return await this.service.getPatrimonioCentroCustoById({
      idPatrimonioCentroCusto,
    });
  }

  async createPatrimonioCentroCusto(
    idCentroCusto?: number | null,
    status?: number | null,
  ): Promise<number> {
    const response = await this.service.createPatrimonioCentroCusto({
      idCentroCusto,
      status,
    });
    return response.idPatrimonioCentroCusto;
  }

  async updatePatrimonioCentroCusto(
    idPatrimonioCentroCusto: number,
    idCentroCusto?: number | null,
    status?: number | null,
  ): Promise<void> {
    await this.service.updatePatrimonioCentroCusto({
      idPatrimonioCentroCusto,
      idCentroCusto,
      status,
    });
  }

  async deletePatrimonioCentroCusto(
    idPatrimonioCentroCusto: number,
  ): Promise<void> {
    await this.service.deletePatrimonioCentroCusto({
      idPatrimonioCentroCusto,
    });
  }

  async getPatrimonioChecklistInfo(
    idPatrimonioCentroCusto: number,
    idPatrimonioMaquinaEquip?: number,
    idInspecaoPatrimonio?: number,
  ): Promise<PatrimonioChecklistInfo> {
    const response = await this.service.getPatrimonioChecklistInfo({
      idPatrimonioCentroCusto,
      idPatrimonioMaquinaEquip,
      idInspecaoPatrimonio,
    });
    return response;
  }

  //#endregion



  //#region Patrimonio Maquina Equip

  async getAllPatrimonioMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    descricao?: string | null,
    status?: number | null,
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<PatrimonioMaquinaEquipListaModel>> {
    return await this.service.getAllPatrimonioMaquinaEquip({
      idPatrimonioCentroCusto: idPatrimonioCentroCusto ?? undefined,
      descricao: descricao ?? undefined,
      status: status ?? undefined,
      page,
      rowsPerPage,
    });
  }

  async getPatrimonioMaquinaEquipById(
    idPatrimonioMaquinaEquip: number,
  ): Promise<PatrimonioMaquinaEquipModel> {
    return await this.service.getPatrimonioMaquinaEquipById({
      idPatrimonioMaquinaEquip,
    });
  }

  async createPatrimonioMaquinaEquip(
    idPatrimonioCentroCusto?: number | null,
    idChecklistMaquinaEquip?: number | null,
    descricao?: string | null,
    status?: number | null,
  ): Promise<number> {
    const response = await this.service.createPatrimonioMaquinaEquip({
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      descricao,
      status,
    });
    return response.idPatrimonioMaquinaEquip;
  }

  async updatePatrimonioMaquinaEquip(
    idPatrimonioMaquinaEquip: number,
    idPatrimonioCentroCusto?: number | null,
    idChecklistMaquinaEquip?: number | null,
    descricao?: string | null,
    status?: number | null,
  ): Promise<void> {
    await this.service.updatePatrimonioMaquinaEquip({
      idPatrimonioMaquinaEquip,
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      descricao,
      status,
    });
  }

  async deletePatrimonioMaquinaEquip(
    idPatrimonioMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deletePatrimonioMaquinaEquip({
      idPatrimonioMaquinaEquip,
    });
  }

  //#endregion



  //#region Patrimonio Checklist Maquina Equip

  async getAllPatrimonioChecklistMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    idPatrimonioMaquinaEquip: number | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<PatrimonioChecklistMaquinaEquipModel>> {
    return await this.service.getAllPatrimonioChecklistMaquinaEquip({
      idPatrimonioCentroCusto,
      idPatrimonioMaquinaEquip,
      status,
      page,
      rowsPerPage,
    });
  }

  async getPatrimonioChecklistMaquinaEquipById(
    idPatrimonioChecklistMaquinaEquip: number,
  ): Promise<PatrimonioChecklistMaquinaEquipModel> {
    return await this.service.getPatrimonioChecklistMaquinaEquipById({
      idPatrimonioChecklistMaquinaEquip,
    });
  }

  async createPatrimonioChecklistMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    idChecklistMaquinaEquip: number | null,
    idPatrimonioMaquinaEquip: number | null,
    metaAprovacao: number | null,
    status: number | null,
  ): Promise<number> {
    const response = await this.service.createPatrimonioChecklistMaquinaEquip({
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      idPatrimonioMaquinaEquip,
      metaAprovacao,
      status,
    });
    return response.idPatrimonioChecklistMaquinaEquip;
  }

  async updatePatrimonioChecklistMaquinaEquip(
    idPatrimonioChecklistMaquinaEquip: number,
    idPatrimonioCentroCusto: number | null,
    idChecklistMaquinaEquip: number | null,
    idPatrimonioMaquinaEquip: number | null,
    metaAprovacao: number | null,
    status: number | null,
  ): Promise<void> {
    await this.service.updatePatrimonioChecklistMaquinaEquip({
      idPatrimonioChecklistMaquinaEquip,
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      idPatrimonioMaquinaEquip,
      metaAprovacao,
      status,
    });
  }

  async deletePatrimonioChecklistMaquinaEquip(
    idPatrimonioChecklistMaquinaEquip: number,
  ): Promise<void> {
    await this.service.deletePatrimonioChecklistMaquinaEquip({
      idPatrimonioChecklistMaquinaEquip,
    });
  }

  //#endregion

  //#region Ocorrencia Inspecao Patrimonio
  async getAllOcorrenciaInspecaoPatrimonio(
    idInspecaoPatrimonio: number,
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<OcorrenciaInspecaoPatrimonioLista>> {
    return this.service.getAllOcorrenciaInspecaoPatrimonio({
      idInspecaoPatrimonio,
      page,
      rowsPerPage,
    });
  }

  async getOcorrenciaInspecaoPatrimonioById(
    idOcorrenciaInspecaoPatrimonio: number,
  ): Promise<OcorrenciaInspecaoPatrimonioModel> {
    const response = await this.service.getOcorrenciaInspecaoPatrimonioById({
      idOcorrenciaInspecaoPatrimonio,
    });
    return {
      ...response,
      limparArquivo1: false,
      limparArquivo2: false,
    };


  }

  async createOcorrenciaInspecaoPatrimonio(
    idInspecaoPatrimonio?: number,
    idInspecaoPatrimonioItens?: number,
    dataCriacao?: Date,
    descricao?: string,
    inspecao?: number,
    arquivo1?: File,
    arquivo2?: File,
    nomeArquivo1?: string,
    nomeArquivo2?: string,
    descricaoArquivo1?: string,
    descricaoArquivo2?: string,
  ): Promise<number> {
    const response = await this.service.createOcorrenciaInspecaoPatrimonio({
      idInspecaoPatrimonio,
      idInspecaoPatrimonioItens,
      dataCriacao,
      descricao,
      inspecao,
      arquivo1,
      arquivo2,
      nomeArquivo1,
      nomeArquivo2,
      descricaoArquivo1,
      descricaoArquivo2,
    });

    return response.idOcorrenciaInspecaoPatrimonio;
  }

  async updateOcorrenciaInspecaoPatrimonio(
    idOcorrenciaInspecaoPatrimonio: number,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    idInspecaoPatrimonio?: number,
    idInspecaoPatrimonioItens?: number,
    dataCriacao?: Date,
    descricao?: string,
    inspecao?: number,
    arquivo1?: File,
    arquivo2?: File,
    nomeArquivo1?: string,
    nomeArquivo2?: string,
    descricaoArquivo1?: string,
    descricaoArquivo2?: string,

  ): Promise<void> {
    await this.service.updateOcorrenciaInspecaoPatrimonio({
      idOcorrenciaInspecaoPatrimonio,
      idInspecaoPatrimonio,
      idInspecaoPatrimonioItens,
      dataCriacao,
      descricao,
      inspecao,
      arquivo1,
      arquivo2,
      nomeArquivo1,
      nomeArquivo2,
      descricaoArquivo1,
      descricaoArquivo2,
      limparArquivo1,
      limparArquivo2,
    });
  }

  async deleteOcorrenciaInspecaoPatrimonio(
    idOcorrenciaInspecaoPatrimonio: number,
  ): Promise<void> {
    await this.service.deleteOcorrenciaInspecaoPatrimonio({ idOcorrenciaInspecaoPatrimonio });
  }

  async downloadOcorrenciaInspecaoPatrimonioArquivos(
    idOcorrenciaInspecaoPatrimonio: number,
    nroArquivo: number,
  ): Promise<Blob> {
    return this.service.downloadOcorrenciaInspecaoPatrimonioArquivos({ idOcorrenciaInspecaoPatrimonio, nroArquivo });
  }

  //#endregion

}
